import { useState } from 'react';

import type { CheckoutPayload } from '../../Checkout.utils';

export const useCheckoutPayload = () => {
  const [payload, setPayload] = useState(defaultCheckoutPayload);

  return { payload, setPayload };
};

const defaultCheckoutPayload: CheckoutPayload = {
  wantedTime: '',
  billingAccountId: 'ADD',
  useCredit: true,
  dropoffLocationId: null,
  contactNumber: null,
  includeUtensils: false,
  pickupTip: 0,
};
